<template>
  <!-- 首页精选优惠券 -->
  <div class="loyaltyBox">
    <ul class="fvl" v-if="list.length" :class="{ oneList: list.length === 1 }">
      <li class="fvl" v-for="(item, index) in list" :key="index" @click="toLink(item)">
        <div class="fhud left">
          <div class="condition">{{ item.typeName }}</div>
          <div class="discount discountStr">{{ item.discountStr }}</div>
          <div class="discount thresholdStr fc">{{ item.thresholdStr }}</div>
        </div>
        <div class="fc right textBreak" v-html="item.rightName"></div>
      </li>
    </ul>
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue'

import { useRouter } from 'vue-router'
export default {
  props: ['datas'],
  setup(props) {
    let { datas } = toRefs(props)
    const router = useRouter()
    const state = reactive({
      list: datas
    })
    const toLink = item => {
      router.push({
        path: '/couponDetail',
        query: {
          couponId: item.id,
          from: 'home',
          event: '查看优惠券详情'
        }
      })
    }
    return {
      ...toRefs(state),
      toLink
    }
  }
}
</script>

<style lang="scss" scoped>
.loyaltyBox {
  width: 100%;
  overflow-x: scroll;
  margin: 12px 0 37px;
  ul {
    width: 390px;
    overflow-x: scroll;
  }
  .oneList {
    width: 100%;
  }
  li {
    width: 180px;
    margin-right: 15px;
    background: #fff;
    float: left;
    text-align: center;
    border-radius: 5px;
    overflow: hidden;
  }
  .discountStr {
    margin: 2px 0;
  }
  .left {
    background: rgb(48, 136, 197);
    color: #fff;
    padding: 5px;
    box-sizing: border-box;
    flex-direction: column;
  }
  .right {
    max-width: 65px;
    height: 60px;
    color: rgb(51, 51, 51);
    font-size: 12px;
    text-align: left;
    padding: 0 8px;
    background-color: #eee;
  }
  .condition {
    font-size: 12px;
  }
  .discount {
    font-size: 12px;
    font-weight: bold;
  }
  .thresholdStr {
    word-break: normal;
  }
}
</style>
